import 'bootstrap/dist/css/bootstrap.css';
import { useState, useEffect, useMemo } from 'react';
import ComissaoService from '../../services/comissaoService';

// --- INTERFACES ---
interface ParceiroSaldoDTO {
  id: number;
  nome: string;
  tipo: 'PROMOTORA' | 'REGIONAL';
  saldoDevedorTotal: number;
}

interface NegociacaoDTO {
  id: number;
  idParceiro: number;
  nomeNegociacao: string;
  valorTotal: number;
  saldoRestante: number;
  qtdParcelas: number;
  dataCriacao: string;
  status: 'EM_ANDAMENTO' | 'QUITADO' | 'PENDENTE';
  parcelas?: ParcelaDTO[];
}

interface ParcelaDTO {
  id: number;
  numero: number;
  valor: number;
  dataVencimento: string;
  dataPagamento?: string;
  status: 'NAO_PAGO' | 'PAGO' | 'ATRASADO';
}

// --- ÍCONES (SVG Inline) ---
const Icons = {
  Wallet: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/></svg>,
  List: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/></svg>,
  Check: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/></svg>,
  Dollar: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/></svg>,
  Back: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/></svg>,
  Alert: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/></svg>,
  Search: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>
};

function NegociacaoSaldoComponent() {
  
  // INJECT BOOTSTRAP
  useEffect(() => {
    const link = document.createElement('link');
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => { if(document.head.contains(link)) document.head.removeChild(link); };
  }, []);

  // --- SERVICE INSTANCE ---
  const comissaoService = useMemo(() => new ComissaoService(), []);

  // --- STATES ---
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState<'LISTA_PARCEIROS' | 'DETALHE_NEGOCIACAO' | 'PARCELAS'>('LISTA_PARCEIROS');
  const [alert, setAlert] = useState<{msg: string, type: string} | null>(null);

  // Dados
  const [parceiros, setParceiros] = useState<ParceiroSaldoDTO[]>([]);
  const [negociacoes, setNegociacoes] = useState<NegociacaoDTO[]>([]);
  
  // Filtros Parceiros
  const [filtroNomeParceiro, setFiltroNomeParceiro] = useState('');
  const [filtroTipoParceiro, setFiltroTipoParceiro] = useState('');

  // Filtros Negociações
  const [filtroNomeNegociacao, setFiltroNomeNegociacao] = useState('');
  const [filtroStatusNegociacao, setFiltroStatusNegociacao] = useState('');

  // Seleções
  const [selectedParceiro, setSelectedParceiro] = useState<ParceiroSaldoDTO | null>(null);
  const [selectedNegociacao, setSelectedNegociacao] = useState<NegociacaoDTO | null>(null);

  // Estado para Limite de Parcelas configurado
  const [maxParcelasPermitidas, setMaxParcelasPermitidas] = useState(12);

  // Modal State
  const [showModalCriar, setShowModalCriar] = useState(false);
  const [novoAcordo, setNovoAcordo] = useState({
    nome: '',
    valor: 0,
    parcelas: 1,
    primeiroVencimento: ''
  });

  // --- INIT ---
  useEffect(() => {
    carregarParceiros();
    carregarRegrasGerais();
  }, []);

  // --- SERVICE CALLS ---

  const carregarRegrasGerais = async () => {
    try {
      const resp = await comissaoService.buscarParametrosGerais();
      if (resp.data && resp.data.maximoParcelasNegociacao) {
        setMaxParcelasPermitidas(resp.data.maximoParcelasNegociacao);
      }
    } catch (error) {
      console.error("Erro ao carregar limite de parcelas", error);
    }
  };

  const carregarParceiros = async () => {
    setLoading(true);
    try {
      const response = await comissaoService.listarParceirosDevedores();
      setParceiros(response.data);
    } catch (error) {
      console.error("Erro ao carregar parceiros", error);
      setAlert({ msg: 'Erro ao carregar lista de devedores.', type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  const carregarNegociacoes = async (parceiro: ParceiroSaldoDTO) => {
    setLoading(true);
    setFiltroNomeNegociacao('');
    setFiltroStatusNegociacao('');
    
    try {
      const response = await comissaoService.listarNegociacoesPorParceiro(parceiro.id);
      setNegociacoes(response.data);
      setSelectedParceiro(parceiro);
      setViewMode('DETALHE_NEGOCIACAO');
    } catch (error) {
      console.error("Erro ao carregar negociações", error);
      setAlert({ msg: 'Erro ao carregar histórico de negociações.', type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  // --- FILTER LOGIC ---
  const parceirosFiltrados = parceiros.filter(p => {
    const matchNome = p.nome.toLowerCase().includes(filtroNomeParceiro.toLowerCase());
    const matchTipo = filtroTipoParceiro ? p.tipo === filtroTipoParceiro : true;
    return matchNome && matchTipo;
  });

  const negociacoesFiltradas = negociacoes.filter(n => {
    const matchNome = (n.nomeNegociacao || '').toLowerCase().includes(filtroNomeNegociacao.toLowerCase());
    const matchStatus = filtroStatusNegociacao ? n.status === filtroStatusNegociacao : true;
    return matchNome && matchStatus;
  });

  // --- ACTIONS: NEGOCIAÇÃO ---
  const abrirModalCriacao = () => {
    if(!selectedParceiro) return;
    setNovoAcordo({
      nome: '',
      valor: selectedParceiro.saldoDevedorTotal, 
      parcelas: 1,
      primeiroVencimento: new Date().toISOString().split('T')[0]
    });
    setShowModalCriar(true);
  };

  const handleSalvarNegociacao = async () => {
    if(!selectedParceiro) return;
    if(novoAcordo.valor <= 0 || novoAcordo.parcelas < 1 || !novoAcordo.nome) {
      setAlert({ msg: 'Preencha todos os campos corretamente.', type: 'warning' });
      return;
    }

    setLoading(true);
    
    // Payload adaptado para NegociacaoEstornoDTO
    const payload = {
        idParceiro: selectedParceiro.id,
        // Caso esteja usando o endpoint de estorno específico, precisaria do idEstorno.
        // Se for saldo global, o backend deve tratar (ou use idEstorno dummy se for um DTO estrito)
        // idEstorno: 0, 
        nomeAcordo: novoAcordo.nome,
        valorNegociado: novoAcordo.valor, // Campo novo sugerido para valor livre
        qtdeParcelas: novoAcordo.parcelas,
        taxaJuros: 0, // Taxa de juros (0% neste exemplo simplificado)
        periodicidade: 'MENSAL',
        primeiroVencimento: novoAcordo.primeiroVencimento
    };

    try {
      await comissaoService.negociarEstorno(payload);
      setAlert({ msg: 'Negociação criada com sucesso! Parcelas geradas.', type: 'success' });
      setShowModalCriar(false);
      
      // Recarrega negociações para atualizar a lista
      carregarNegociacoes(selectedParceiro);
      
      // Opcional: Recarregar parceiros para atualizar o saldo devedor total na lista principal
      carregarParceiros(); 
    } catch (error) {
      console.error("Erro ao salvar negociação", error);
      setAlert({ msg: 'Erro ao processar a negociação no servidor.', type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  // --- ACTIONS: PARCELAS ---
  const verParcelas = (negociacao: NegociacaoDTO) => {
    setSelectedNegociacao(negociacao);
    setViewMode('PARCELAS');
  };

  const handleBaixarParcela = async (parcelaId: number) => {
    if(!selectedNegociacao || !selectedParceiro) return;

    try {
        setLoading(true);
        await comissaoService.baixarParcela(parcelaId);
        
        setAlert({ msg: 'Baixa na parcela realizada com sucesso.', type: 'success' });
        
        // Recarregar dados para refletir novo status/saldo
        const response = await comissaoService.listarNegociacoesPorParceiro(selectedParceiro.id);
        const negociacaoAtualizada = response.data.find((n: NegociacaoDTO) => n.id === selectedNegociacao.id);
        
        if (negociacaoAtualizada) {
            setSelectedNegociacao(negociacaoAtualizada);
            setNegociacoes(response.data);
        }
    } catch (error) {
        console.error("Erro ao baixar parcela", error);
        setAlert({ msg: 'Erro ao baixar parcela.', type: 'danger' });
    } finally {
        setLoading(false);
    }
  };

  const handleLiquidarTudo = async () => {
    if(!selectedNegociacao || !selectedParceiro) return;
    if(!window.confirm("Deseja realmente liquidar todas as parcelas restantes?")) return;

    try {
        setLoading(true);
        await comissaoService.liquidarNegociacaoTotal(selectedNegociacao.id);
        setAlert({ msg: 'Todas as parcelas foram liquidadas!', type: 'success' });
        
        const response = await comissaoService.listarNegociacoesPorParceiro(selectedParceiro.id);
        const negociacaoAtualizada = response.data.find((n: NegociacaoDTO) => n.id === selectedNegociacao.id);
        
        if (negociacaoAtualizada) {
            setSelectedNegociacao(negociacaoAtualizada);
            setNegociacoes(response.data);
        }
        // Atualiza saldo geral
        carregarParceiros();
    } catch (error) {
        console.error("Erro ao liquidar negociação", error);
        setAlert({ msg: 'Erro ao liquidar negociação.', type: 'danger' });
    } finally {
        setLoading(false);
    }
  };

  // --- UTILS ---
  const formatMoney = (val: number) => val ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';
  const formatDate = (dateStr: string) => {
      if(!dateStr) return '-';
      try {
          // Ajuste de fuso horário simples para visualização (YYYY-MM-DD vem como UTC geralmente)
          const [ano, mes, dia] = dateStr.split('-');
          if(ano && mes && dia) return `${dia}/${mes}/${ano}`;
          return new Date(dateStr).toLocaleDateString('pt-BR');
      } catch (e) {
          return dateStr;
      }
  };
  
  const getStatusBadge = (status: string) => {
    switch(status) {
      case 'PAGO': return <span className="badge bg-success">Pago</span>;
      case 'ATRASADO': return <span className="badge bg-danger">Atrasado</span>;
      case 'NAO_PAGO': return <span className="badge bg-secondary">A Vencer</span>;
      case 'QUITADO': return <span className="badge bg-success">Quitado</span>;
      case 'EM_ANDAMENTO': return <span className="badge bg-primary">Em Andamento</span>;
      default: return <span className="badge bg-light text-dark">{status}</span>;
    }
  };

  // --- RENDER ---
  return (
    <div className="container-fluid p-4 bg-light min-vh-100 font-sans">
      
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h4 className="mb-0 fw-bold text-dark d-flex align-items-center">
            <span className="me-2 text-primary"><Icons.Wallet /></span> 
            Gestão de Saldos e Negociações
          </h4>
          <small className="text-muted">Controle de dívidas, acordos e parcelamento.</small>
        </div>
        {viewMode !== 'LISTA_PARCEIROS' && (
          <button className="btn btn-outline-secondary btn-sm" onClick={() => setViewMode('LISTA_PARCEIROS')}>
            <Icons.Back /> Voltar para Lista
          </button>
        )}
      </div>

      {alert && (
        <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
          {alert.msg}
          <button type="button" className="btn-close" onClick={() => setAlert(null)}></button>
        </div>
      )}

      {/* VIEW 1: LISTA DE PARCEIROS COM DÍVIDA */}
      {viewMode === 'LISTA_PARCEIROS' && (
        <div className="card shadow-sm border-0">
          <div className="card-header bg-white py-3">
             <div className="d-flex justify-content-between align-items-center mb-2">
                 <h6 className="mb-0 fw-bold">Parceiros com Saldo Devedor</h6>
             </div>
             {/* Filtros de Parceiros */}
             <div className="row g-2">
                 <div className="col-md-6">
                     <div className="input-group input-group-sm">
                         <span className="input-group-text bg-light"><Icons.Search /></span>
                         <input type="text" className="form-control" placeholder="Buscar por Nome..." 
                             value={filtroNomeParceiro} onChange={e => setFiltroNomeParceiro(e.target.value)} />
                     </div>
                 </div>
                 <div className="col-md-4">
                     <select className="form-select form-select-sm" 
                         value={filtroTipoParceiro} onChange={e => setFiltroTipoParceiro(e.target.value)}>
                         <option value="">Todos os Tipos</option>
                         <option value="PROMOTORA">Promotora</option>
                         <option value="REGIONAL">Regional</option>
                     </select>
                 </div>
                 <div className="col-md-2 text-end">
                    <span className="badge bg-secondary">{parceirosFiltrados.length} encontrados</span>
                 </div>
             </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-4">Parceiro</th>
                    <th>Tipo</th>
                    <th className="text-end">Saldo Devedor Total</th>
                    <th className="text-center pe-4">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {parceirosFiltrados.length > 0 ? parceirosFiltrados.map(p => (
                    <tr key={p.id}>
                      <td className="ps-4 fw-bold">{p.nome}</td>
                      <td><span className="badge bg-light text-dark border">{p.tipo}</span></td>
                      <td className="text-end fw-bold text-danger">{formatMoney(p.saldoDevedorTotal)}</td>
                      <td className="text-center pe-4">
                        <button className="btn btn-primary btn-sm" onClick={() => carregarNegociacoes(p)}>
                          Ver Negociações
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                        <td colSpan={4} className="text-center py-4 text-muted">
                            {loading ? 'Carregando...' : 'Nenhum parceiro encontrado com os filtros atuais.'}
                        </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* VIEW 2: LISTA DE NEGOCIAÇÕES DO PARCEIRO */}
      {viewMode === 'DETALHE_NEGOCIACAO' && selectedParceiro && (
        <div className="animate-fade-in">
          <div className="alert alert-info d-flex justify-content-between align-items-center mb-3">
            <div>
              <strong>Parceiro:</strong> {selectedParceiro.nome}
            </div>
            <div>
              <strong>Saldo Devedor Atual:</strong> {formatMoney(selectedParceiro.saldoDevedorTotal)}
            </div>
          </div>

          <div className="card shadow-sm border-0">
            <div className="card-header bg-white py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0 fw-bold">Acordos Realizados</h6>
                  <button className="btn btn-success btn-sm" onClick={abrirModalCriacao}>
                    <span className="me-1">+</span> Nova Negociação
                  </button>
                </div>
                {/* Filtros de Negociação */}
                 <div className="row g-2 bg-light p-2 rounded mx-0 mb-1">
                     <div className="col-md-6">
                         <input type="text" className="form-control form-control-sm" placeholder="Buscar acordo por nome..." 
                             value={filtroNomeNegociacao} onChange={e => setFiltroNomeNegociacao(e.target.value)} />
                     </div>
                     <div className="col-md-4">
                         <select className="form-select form-select-sm" 
                             value={filtroStatusNegociacao} onChange={e => setFiltroStatusNegociacao(e.target.value)}>
                             <option value="">Todos os Status</option>
                             <option value="EM_ANDAMENTO">Em Andamento</option>
                             <option value="QUITADO">Quitado</option>
                         </select>
                     </div>
                 </div>
            </div>
            <div className="card-body p-0">
               {negociacoesFiltradas.length === 0 ? (
                 <div className="p-5 text-center text-muted">
                    {loading ? 'Carregando...' : 'Nenhuma negociação encontrada para este parceiro.'}
                 </div>
               ) : (
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="ps-4">Nome do Acordo</th>
                        <th>Data</th>
                        <th className="text-end">Valor Total</th>
                        <th className="text-end">Saldo Restante</th>
                        <th className="text-center">Parcelas</th>
                        <th className="text-center">Status</th>
                        <th className="text-center pe-4">Detalhes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {negociacoesFiltradas.map(n => (
                        <tr key={n.id}>
                          <td className="ps-4 fw-bold text-primary">{n.nomeNegociacao}</td>
                          <td>{formatDate(n.dataCriacao)}</td>
                          <td className="text-end">{formatMoney(n.valorTotal)}</td>
                          <td className="text-end fw-bold">{formatMoney(n.saldoRestante)}</td>
                          <td className="text-center">{n.qtdParcelas}x</td>
                          <td className="text-center">{getStatusBadge(n.status)}</td>
                          <td className="text-center pe-4">
                            <button className="btn btn-outline-primary btn-sm" onClick={() => verParcelas(n)}>
                              <Icons.List /> Acompanhar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
               )}
            </div>
          </div>
        </div>
      )}

      {/* VIEW 3: DETALHES DAS PARCELAS (DRILL-DOWN) */}
      {viewMode === 'PARCELAS' && selectedNegociacao && (
        <div className="animate-fade-in">
           <button className="btn btn-sm btn-link text-decoration-none mb-2 ps-0" onClick={() => setViewMode('DETALHE_NEGOCIACAO')}>
             &lt; Voltar para Acordos
           </button>

           <div className="card shadow-sm border-0 mb-3">
             <div className="card-body bg-white d-flex justify-content-between align-items-center">
                <div>
                   <h5 className="fw-bold mb-1">{selectedNegociacao.nomeNegociacao}</h5>
                   <span className="text-muted small">Progresso do Pagamento</span>
                </div>
                <div className="text-end">
                   <h4 className={`mb-0 fw-bold ${selectedNegociacao.saldoRestante > 0 ? 'text-danger' : 'text-success'}`}>
                     {formatMoney(selectedNegociacao.saldoRestante)}
                   </h4>
                   <small className="text-muted">Restante a Pagar</small>
                </div>
             </div>
           </div>

           <div className="card shadow-sm border-0">
             <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
               <h6 className="mb-0 fw-bold">Parcelas do Acordo</h6>
               {selectedNegociacao.saldoRestante > 0 && (
                 <button className="btn btn-danger btn-sm" onClick={handleLiquidarTudo}>
                   <Icons.Dollar /> Liquidar Tudo
                 </button>
               )}
             </div>
             <div className="card-body p-0">
               <div className="table-responsive">
                 <table className="table table-hover align-middle mb-0">
                   <thead className="table-light">
                     <tr>
                       <th className="ps-4 text-center">#</th>
                       <th>Vencimento</th>
                       <th>Pagamento</th>
                       <th className="text-end">Valor</th>
                       <th className="text-center">Status</th>
                       <th className="text-center pe-4">Ações</th>
                     </tr>
                   </thead>
                   <tbody>
                     {selectedNegociacao.parcelas?.map(p => (
                       <tr key={p.id} className={p.status === 'ATRASADO' ? 'table-danger' : ''}>
                         <td className="ps-4 text-center fw-bold text-muted">{p.numero}</td>
                         <td className={p.status === 'ATRASADO' ? 'text-danger fw-bold' : ''}>{formatDate(p.dataVencimento)}</td>
                         <td>{p.dataPagamento ? formatDate(p.dataPagamento) : '-'}</td>
                         <td className="text-end">{formatMoney(p.valor)}</td>
                         <td className="text-center">{getStatusBadge(p.status)}</td>
                         <td className="text-center pe-4">
                           {p.status !== 'PAGO' ? (
                             <button className="btn btn-success btn-sm" title="Dar Baixa" onClick={() => handleBaixarParcela(p.id)}>
                               <Icons.Check /> Baixar
                             </button>
                           ) : (
                             <span className="text-success small"><Icons.Check /> Quitado</span>
                           )}
                         </td>
                       </tr>
                     ))}
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
        </div>
      )}

      {/* MODAL CRIAR NEGOCIAÇÃO */}
      {showModalCriar && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Nova Negociação</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModalCriar(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning py-2 small">
                  O valor máximo para negociação é: <strong>{formatMoney(selectedParceiro?.saldoDevedorTotal || 0)}</strong>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-bold">Nome da Negociação (Identificador)</label>
                  <input type="text" className="form-control" placeholder="Ex: Acordo Dívida 2023"
                    value={novoAcordo.nome}
                    onChange={e => setNovoAcordo({...novoAcordo, nome: e.target.value})}
                  />
                </div>

                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="form-label small fw-bold">Valor do Acordo</label>
                    <input type="number" className="form-control"
                      value={novoAcordo.valor}
                      onChange={e => setNovoAcordo({...novoAcordo, valor: parseFloat(e.target.value)})}
                    />
                  </div>
                  <div className="col-md-6">
                     <label className="form-label small fw-bold">Qtd. Parcelas (Máx: {maxParcelasPermitidas})</label>
                     <select className="form-select"
                       value={novoAcordo.parcelas}
                       onChange={e => setNovoAcordo({...novoAcordo, parcelas: parseInt(e.target.value)})}
                     >
                       {Array.from({ length: maxParcelasPermitidas }, (_, i) => i + 1).map(n => (
                         <option key={n} value={n}>{n}x</option>
                       ))}
                     </select>
                  </div>
                  <div className="col-12 mt-2">
                     <label className="form-label small fw-bold">Data 1º Vencimento</label>
                     <input type="date" className="form-control"
                        value={novoAcordo.primeiroVencimento}
                        onChange={e => setNovoAcordo({...novoAcordo, primeiroVencimento: e.target.value})}
                     />
                  </div>
                </div>

                <div className="mt-4 bg-light p-3 rounded border">
                  <small className="text-muted d-block mb-1">Simulação:</small>
                  <div className="d-flex justify-content-between fw-bold">
                    <span>{novoAcordo.parcelas}x de</span>
                    <span className="text-primary">{formatMoney(novoAcordo.valor / (novoAcordo.parcelas || 1))}</span>
                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModalCriar(false)}>Cancelar</button>
                <button type="button" className="btn btn-primary" onClick={handleSalvarNegociacao}>
                  {loading ? 'Processando...' : 'Gerar e Aprovar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default NegociacaoSaldoComponent;